import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap";

const TopCustomerModal = ({ isOpen, toggle, topCustomers }) => {
  return (
    <Modal isOpen={isOpen} size="lg" toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Top Customers</ModalHeader>
      <ModalBody>
        <Row>
          {topCustomers.map((customer, index) => (
            <Col key={index} md={6}>
              <Card className="mb-4 p-2 bg-light">
                <CardBody className="d-flex align-items-center gap-3">
                  <img
                    src={customer.image}
                    alt={customer.name}
                    className="img-fluid rounded-circle me-2" 
                    width="60" 
                  />
                  <div>
                    <h5 className="mb-0">{customer.name}</h5>
                    <p className="mb-0">Total Spent: {customer.totalSpent}</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default TopCustomerModal;
